var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "250px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索简称...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchBankAccount
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('Select', {
    staticStyle: {
      "width": "220px",
      "margin-right": "30px"
    },
    attrs: {
      "placeholder": "筛选公司",
      "label-in-value": "",
      "clearable": ""
    },
    on: {
      "on-change": _vm.choseCompany
    },
    model: {
      value: _vm.company,
      callback: function ($$v) {
        _vm.company = $$v;
      },
      expression: "company"
    }
  }, _vm._l(_vm.companyList, function (item) {
    return _c('Option', {
      key: item._id,
      attrs: {
        "value": item._id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.totalRows) + "条")]), _c('Page', {
    staticStyle: {
      "margin-right": "24px"
    },
    attrs: {
      "total": _vm.totalRows,
      "page-size": 15,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadBill
    }
  }), _c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.openAddBillDrawer();
      }
    }
  }, [_vm._v("新增票据")])], 1)]), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.billList,
      "height": _vm.tableHeight
    }
  })], 1), _c('AddBillDrawer', {
    ref: "AddBillDrawer"
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }